interface ResponsiveBreakpoint {
  breakpoint: { max: number; min: number };
  items: number;
}

export interface CarouselResponsiveConfig {
  desktop: ResponsiveBreakpoint;
  tablet: ResponsiveBreakpoint;
  mobile: ResponsiveBreakpoint;
}

export const CAROUSEL_RESPONSIVE: CarouselResponsiveConfig = {
  desktop: {
    breakpoint: { max: 3000, min: 1375 },
    items: 3
  },
  tablet: {
    breakpoint: { max: 1374, min: 900 },
    items: 2
  },
  mobile: {
    breakpoint: { max: 899, min: 0 },
    items: 1
  }
};

export const CAROUSEL_AUTOPLAY_INTERVAL_MS = 5000;

export type CarouselArrowDirection = "left" | "right";

export const RMC_ARROW_SELECTORS: Record<CarouselArrowDirection, string> = {
  left: ".react-multiple-carousel__arrow--left",
  right: ".react-multiple-carousel__arrow--right"
};
